const summaryInitialState = {
  visitors: [],
  topEngagements: [],
  showVisitorTable: false,
  title: '',
  campaignType: '',
  isPTActive: false,
  createdDate: '',
  createdBy: '',
  website: '',
  pageViews: 0,
  cardViews: 0,
  cardLoaded: 0,
  engagementTakes: 0,
  conversions: 0,
  averageTimeSpent: 0,
  segmentId: '',
  segmentTitle: '',
  pages: [],
  visitorsLocation: [],
  topWeekDays: [],
  domainConfig: {
    exceptions: [],
    type: '',
    domainId: '',
    domainHost: '',
    pageMetaDataDomainConfig: {
      fromPublishedDate: '',
      tags: [],
      categories: [],
      authors: [],
    },
  },
  visualization: {
    cardSize: {
      width: 0,
      height: 0,
      autoWidth: true,
    },
    darkTheme: false,
    language: 'en',
    primaryColor: '#395EF9',
  },
  campaignData: {},
};

const agentOverviewState = {
  data: {
    summary: { ...summaryInitialState },
  },
  variantData: {
    summary: { ...summaryInitialState },
  },
  isSummaryLoading: true,
  isVariantSummaryLoading: true,
};

export default agentOverviewState;
